export enum Environment {
  development = 'development',
  testing = 'testing',
  staging = 'staging',
  production = 'production'
}
